import React, {type FC} from 'react';
import {IconButton, IconButtonThemes} from '@wix/wix-ui-tpa/cssVars';
import {ChevronLeft, ChevronRight} from '@wix/wix-ui-icons-common/on-stage';
import classNames from 'classnames';
import {classes} from './MediaNavigationArrows.st.css';
import s from './MediaNavigationArrows.scss';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';
import {useProductGallery} from '../ProductGalleryProvider/ProductGalleryProvider';

export enum MediaNavigationArrowsDataHook {
  Root = 'MediaNavigationArrows.Root',
  LeftArrow = 'MediaNavigationArrows.LeftArrow',
  RightArrow = 'MediaNavigationArrows.RightArrow',
}

export const MediaNavigationArrows: FC = () => {
  const {navigateLeft, navigateRight} = useProductGallery();

  const handleLeft = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const button = e.currentTarget;
    navigateLeft();
    requestAnimationFrame(() => button.focus());
  };

  const handleRight = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const button = e.currentTarget;
    navigateRight();
    requestAnimationFrame(() => button.focus());
  };

  return (
    <ConditionalRender
      by="productPage_showMainMediaNavArrows"
      className={s.root}
      dataHook={MediaNavigationArrowsDataHook.Root}>
      <div className={classNames(s.arrowContainer, s.left)}>
        <IconButton
          theme={IconButtonThemes.Box}
          type="button"
          aria-label="Previous"
          onClick={handleLeft}
          className={classNames(s.arrowButton, classes.arrowButton)}
          data-hook={MediaNavigationArrowsDataHook.LeftArrow}
          icon={<ChevronLeft className={s.chevron} />}
        />
      </div>

      <div className={classNames(s.arrowContainer, s.right)}>
        <IconButton
          theme={IconButtonThemes.Box}
          type="button"
          aria-label="Next"
          onClick={handleRight}
          className={classNames(s.arrowButton, classes.arrowButton)}
          data-hook={MediaNavigationArrowsDataHook.RightArrow}
          icon={<ChevronRight className={s.chevron} />}
        />
      </div>
    </ConditionalRender>
  );
};
